export const serverUrl = process.env.SERVER_BASE_URL // server地址
console.log(serverUrl, 'test----环境地址')

export const imgObject = {
  loginImg: 'https://sme-1256044673.cos.ap-chengdu.myqcloud.com/' + 'suining/SUINING14C828AF77274C27820625CC0B43BDE8.png' // 登录注册背景图
}



// WEBPACK FOOTER //
// ./src/utils/const.js